// src/components/ProtectedRoute.tsx
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { ApiKeysContext } from '../contexts/ApiKeysContext';

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const { isApiKeysSet } = useContext(ApiKeysContext);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isApiKeysSet === null) {
    // Still loading the API keys status
    return null; // Or a loading indicator
  }

  // Prevent redirect loop if already on the add-api-keys page
  if (!isApiKeysSet && location.pathname !== '/add-api-keys') {
    return <Navigate to="/add-api-keys" replace />;
  }

  return children;
};

export default ProtectedRoute;
